<template>
  <div
    class="detailed-mode-header-root"
    v-bind:class="{ 'overflow': this.indicatorItem.getOverflowLevel() !== 'ok' }"
  >
    <div class="content">
      <div>{{indicatorItem.resource.Name}}</div>
      <div>
        <span>{{indicatorItem.data.Value}}</span>
        <span>{{indicatorItem.resource.Unit}}</span>
      </div>
    </div>
    <div class="arrow"></div>
  </div>
</template>

<script>
export default {
  name: 'DetailedModeHeader',
  props: ['indicatorItem']
}
</script>

<style lang="less">
@import '../app.less';

.detailed-mode-header-root {
  display: flex;
  flex-direction: column;
  cursor: pointer;

  > .content {
    background-image: @ok-gradient;
    padding: 0.5rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    > div:first-child {
      font-size: @biggest-size;
      font-weight: bold;
    }

    > div:last-child {
      margin-top: 0.5rem;
      font-size: @biggest-size;
    }
  }

  &.overflow > .content {
    background-image: @warning-gradient;
  }

  > .arrow {
    margin-bottom: 0.5rem;
    align-self: center;
    width: 0;
    height: 0;
    border-left: 1.5rem solid transparent;
    border-right: 1.5rem solid transparent;
    border-top: 1.5rem solid @ok-color;
  }

  &.overflow > .arrow {
    border-top: 1.5rem solid @warning-color;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DetailedModeHeader.vue